import { createContext } from 'react';

import { MinMax } from '../../core/types/min-max.js';
import { XScale } from '../types/histogram.js';

export interface HistogramXScaleContextProps {
  initialXScale: XScale;
  xScale: XScale;
  minMaxBoundaries: MinMax;
}

export const HistogramXScale = createContext<
  HistogramXScaleContextProps | undefined
>(undefined);

HistogramXScale['displayName'] = 'HistogramXScale';
